import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageHome from 'Pages/home';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Route exact path={`${match.url}/`} component={ PageHome } />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;